import React, { useMemo } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client';

import {
	GITHUB_ICON_EXPERIMENT_DEFAULT,
	GITHUB_ICON_EXPERIMENT_NAME,
	GITHUB_ICON_EXPERIMENT_PARAM,
} from '../../../../common/constants/experiments';
import { type PrimaryProductKey, PrimaryProductKeys } from '../../../../common/constants/products';

import { AllAppsConfluenceFirst } from './search-all-apps-icon/AllAppsConfluenceFirst';
import { AllAppsJiraFirst } from './search-all-apps-icon/AllAppsJiraFirst';
import { AllAppsJiraFirstWithGithub } from './search-all-apps-icon/AllAppsJiraFirstWithGithub';

/**
 * All Jira users are intentionally exposed to this experiment (not just GitHub-connected users).
 * The pill group icon is for brand awareness — we want to measure if showing GitHub drives
 * recognition and connection. The dropdown (app-selector) separately gates on connection status
 * since it's a functional feature that requires GitHub to be connected.
 */
export const useJiraAllAppsIcon = (product?: PrimaryProductKey): React.JSX.Element => {
	return useMemo(() => {
		if (product !== PrimaryProductKeys.Jira) {
			return <AllAppsConfluenceFirst />;
		}

		const showGitHubIcon =
			FeatureGates.getExperimentValue<string>(
				GITHUB_ICON_EXPERIMENT_NAME,
				GITHUB_ICON_EXPERIMENT_PARAM,
				GITHUB_ICON_EXPERIMENT_DEFAULT,
			) === 'true';

		return showGitHubIcon ? <AllAppsJiraFirstWithGithub /> : <AllAppsJiraFirst />;
	}, [product]);
};
